/**
 * Shared metadata for published legal pages (I'd Go Back™).
 * Keep contactEmail in sync with apps/mobile/app.config.js → extra.legalUrls.contactEmail
 */
export const LEGAL_META = {
  brandName: "I'd Go Back",
  brandMark: "I'd Go Back™",
  siteName: 'idgoback.com',
  legalEntityName: 'Kevin Martin',
  dataControllerName: 'Kevin Martin',
  operatorLine:
    "The I'd Go Back App is operated by Kevin Martin, Owner and CEO of the I'd Go Back App, based in California, United States (“we,” “us,” or “our”).",
  contactEmail: 'legal@idgoback.com',
  privacyEmail: 'legal@idgoback.com',
  supportEmail: 'support@idgoback.com',
  itEmail: 'it@idgoback.com',
  infoEmail: 'info@idgoback.com',
  childSafetyContactName: 'Kevin Martin',
  childSafetyContactEmail: 'legal@idgoback.com',
  effectiveDate: 'May 24, 2026',
  lastUpdated: 'June 20, 2026',
  minimumAge: 13,
  governingState: 'California',
  governingVenue: 'Los Angeles County, California',
} as const;

export const LEGAL_PATHS = {
  privacy: '/privacy',
  terms: '/terms',
  communityGuidelines: '/community-guidelines',
  childSafetyStandards: '/child-safety-standards',
  cookies: '/cookies',
  support: '/support',
  accountDeletion: '/account-deletion',
  deleteData: '/delete-data',
} as const;

export type LegalSection = {
  id: string;
  title: string;
  paragraphs: string[];
  listItems?: string[];
};
